import { graphql } from "../gql";

export const updateQueueMutationDoc = graphql(`
  mutation updateQueue($input: UpdateQueueInput!) {
    updateQueue(input: $input) {
      queue {
        author {
          id
          firstName
          lastName
          userType
          email
        }
        createdAt
        description
        id
        indexedFilterTags
        name
      }
    }
  }
`);
